import { FONT_SIZES, FONT_WEIGHTS } from '../../../Theme';
import {
  SITE_HEADER_CONTENT_HEIGHT_MOBILE_PX,
  SITE_HEADER_CONTENT_HEIGHT_PX,
} from '../../../styles/navigation/HeaderStyles';
/** Shared Airbnb-style listing section tokens (campaign + influencer detail). */

/** Matches FooterContent / marketing category-aligned max width. */
export const LISTING_DETAIL_MAX_WIDTH_PX = 1280;
/** Matches FooterContent horizontal padding. */
export const LISTING_DETAIL_PADDING_X_PX = 16;
/**
 * Space under the fixed header before listing breadcrumbs.
 * HeaderOffset already clears the header; keep this tight.
 */
export const LISTING_DETAIL_PADDING_TOP = {
  xs: 0,
  influencerSidebar: 0.5,
};
export const SITE_HEADER_HEIGHT_PX = SITE_HEADER_CONTENT_HEIGHT_PX;
export const SITE_HEADER_HEIGHT_MOBILE_PX = SITE_HEADER_CONTENT_HEIGHT_MOBILE_PX;
/** Match Header.js — main site header is visible when scrollY is below this. */
export const SITE_HEADER_REVEAL_SCROLL_PX = 10;

export function scrollToListingSection(sectionId) {
  document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export function getListingDetailHeaderOcclusionPx(viewportWidth) {
  const width = viewportWidth ?? (typeof window !== 'undefined' ? window.innerWidth : 769);
  return width >= 769 ? SITE_HEADER_HEIGHT_PX : SITE_HEADER_HEIGHT_MOBILE_PX;
}

export const listingDetailSectionTitle = (theme) => ({
  fontWeight: FONT_WEIGHTS.strong,
  fontSize: FONT_SIZES.title,
  color: theme.palette.text.primary,
  mb: { xs: 2, md: 2.5 },
  letterSpacing: '-0.02em',
  lineHeight: 1.2,
});

/** Thin divider between major sections only. */
export const listingDetailSectionDividerSx = {
  pb: { xs: 4, md: 5 },
  mb: { xs: 4, md: 5 },
  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
};

/** Uppercase micro heading for fact clusters (Known on Millet, Pay rate, …). */
export const listingDetailFactHeadingSx = (theme) => ({
  fontWeight: FONT_WEIGHTS.strong,
  fontSize: FONT_SIZES.bodySm,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
  mb: 1,
  lineHeight: 1.3,
});

/** Body line inside a fact cluster. */
export const listingDetailFactLineSx = (theme) => ({
  fontSize: FONT_SIZES.body,
  fontWeight: FONT_WEIGHTS.regular,
  lineHeight: 1.45,
  color: theme.palette.text.primary,
  wordBreak: 'break-word',
});
